"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApplication = void 0;
const tsyringe_1 = require("tsyringe");
const IndexDbConfigurationManager_1 = require("../configuration/indexDb/IndexDbConfigurationManager");
const globalSymbols_1 = require("../../globalSymbols");
const serviceExtensions_1 = require("../../serviceExtensions");
const MainView_1 = require("../../views/MainView");
const SongManager_1 = require("../music/SongManager");
const MMMConfigurationDatabase_1 = require("../configuration/indexDb/MMMConfigurationDatabase");
const ResourceManager_1 = require("../resourceSystem/ResourceManager");
let DefaultApplication = class DefaultApplication {
    constructor() {
    }
    get MajorVersion() {
        return 2;
    }
    get MinorVersion() {
        return 0;
    }
    configureContainer(containerBuilder) {
        if (containerBuilder != null) {
            containerBuilder(new serviceExtensions_1.ServiceExtensions(this));
        }
        tsyringe_1.container.registerInstance(globalSymbols_1.TLogger, this.logger);
        tsyringe_1.container.registerInstance(globalSymbols_1.TConfigManager, this.configurationManager);
        tsyringe_1.container.registerInstance(globalSymbols_1.TSongManager, this.songManager);
        tsyringe_1.container.registerInstance(globalSymbols_1.TResourceManager, this.resourceManager);
        return this;
    }
    addLogger(logger) {
        this.logger = logger;
        return this;
    }
    useDatabase(databaseBuilder) {
        if (databaseBuilder != null) {
            this.database = databaseBuilder();
        }
        else {
            this.database = new MMMConfigurationDatabase_1.MMMConfigurationDatabase(this.logger, this);
        }
        return this;
    }
    addSongManager(songManagerBuilder) {
        if (songManagerBuilder != null) {
            this.songManager = songManagerBuilder();
        }
        else {
            this.songManager = new SongManager_1.SongManager(this.database);
        }
        return this;
    }
    addConfigurationManager(configBuilder) {
        if (configBuilder != null) {
            this.configurationManager = configBuilder();
        }
        else {
            this.configurationManager = new IndexDbConfigurationManager_1.IndexDbConfigurationManager(this.logger, this.database);
        }
        return this;
    }
    addResourceManager(resourceManagerBuilder) {
        if (resourceManagerBuilder != null) {
            this.resourceManager = resourceManagerBuilder();
        }
        else {
            this.resourceManager = new ResourceManager_1.ResourceManager(this.logger, this.database);
        }
        return this;
    }
    initializeStartupItems() {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.log("Initializing startup items...");
            for (let startupItem of tsyringe_1.container.resolveAll(globalSymbols_1.TStartupItem)) {
                yield startupItem.initialize();
            }
        });
    }
    run(indexPageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initializeStartupItems();
            yield this.loadTheme();
            let body = document.querySelector("#render-body");
            let view = new MainView_1.MainView();
            view.renderBody = body;
            view.afterConstruction();
            yield view.render();
            this.logger.log("Application started.");
        });
    }
    loadTheme() {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.log("Loading css theme...");
            let themeManager = tsyringe_1.container.resolve(globalSymbols_1.TThemeManager);
            let fileRef = document.createElement("link");
            fileRef.rel = "stylesheet";
            fileRef.type = "text/css";
            fileRef.href = themeManager.getSelectedStylesheet();
            document.getElementsByTagName("head")[0].appendChild(fileRef);
            this.logger.log("Theme loaded.");
        });
    }
};
DefaultApplication = __decorate([
    tsyringe_1.injectable(),
    __metadata("design:paramtypes", [])
], DefaultApplication);
exports.DefaultApplication = DefaultApplication;
//# sourceMappingURL=DefaultApplication.js.map